import ValidarInscricaoSuframa, { ICliente } from "app/types/ICliente";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import validaCpfCnpj from "../../../utils/validarCpfCnpj";
import { InputCpfCnpj } from "../../inputs/InputCpfCnpj";

const estilosInputs = require("../../../estilos/inputs.module.scss").default;

export type DadosBasicosClienteNaoCadastradoProps = {
  somenteLeitura: boolean
  dadosBasicosClienteNaoCadastrado: ICliente;
  formularioValidado: boolean;
  permitirAlterarDadosBasicos: boolean;
  onErrorValidacao: (erros: FormikErrors<ICliente>) => void;
  onValidarFormulario: (valor: boolean) => void;
  manterDadosTemporarios: (cliente: ICliente) => void;
  onAlteradoCPFCNPJ: (cpfCnpj: string) => void
};

export const DadosBasicosClienteNaoCadastrado = (props: DadosBasicosClienteNaoCadastradoProps) => {
  const [alteradoCpfCnpj,setAlteradoCpfCnpj] = useState(false)

  const formik = useFormik({
    initialValues: {
      ...props.dadosBasicosClienteNaoCadastrado
    },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
    validate: (values) => {
      const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`;
      const erroSuframa = ValidarInscricaoSuframa(values.InscricaoSuframa) // 462219
      return R.pickBy((val) => globalMU.isNotNullOrEmpty(val), {
        Nome: !values.Nome ? mensagemObrigatorio("Nome") : undefined,
        InscricaoSuframa: values.InscricaoSuframa && erroSuframa.length > 0 ? erroSuframa : undefined, // 462219
      } as FormikErrors<ICliente>)
    }
  });

  const onValidacaoFormularioVerdadeiro = async () => {
    props.onValidarFormulario(true);
    props.onErrorValidacao(null);
  };

  const onValidacaoFormaularioFalso = async (erros: FormikErrors<ICliente>) => {
    props.onValidarFormulario(false);
    props.onErrorValidacao(erros);
  };

  const onValidarDadosFormulario = async () => {
    const erros = await formik.validateForm(formik.values)
    Object.keys(erros).length == 0 ? onValidacaoFormularioVerdadeiro() : onValidacaoFormaularioFalso(erros);
  }

  useEffect(() => {
    props.manterDadosTemporarios(formik.values);
    onValidarDadosFormulario()
  }, [formik.values]);

  const campoCnpjCpf = <>
    <div className="_flex _mb-1">
      <label className="_font-normal w-[160px] _text-right _py-1 _pr-[10px]">CPF / CNPJ</label>
      <InputCpfCnpj
        disabled={!props.permitirAlterarDadosBasicos || props.somenteLeitura}
        className={`_w-[200px]`}
        id="DadosBasicosClienteNaoCadastrado_CpfCnpj"
        autoFocus
        cpfCnpj={formik.values?.CpfCnpj}
        onCpfCnpjModificado={(novoCpfCnpj) => {
          setAlteradoCpfCnpj(true)
          formik.setFieldValue("CpfCnpj", novoCpfCnpj)
          novoCpfCnpj != null && validaCpfCnpj(novoCpfCnpj) && props.onAlteradoCPFCNPJ(novoCpfCnpj)
         }}
      />
    </div>
  </>

  const campoNome = <>
    <div className="_flex _mb-1">
      <label className="_font-normal w-[160px] _text-right _py-1 _pr-[10px]">Nome</label>
      <div><input
        className={`_w-[280px] ${props.formularioValidado && formik.errors.Nome != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao}`}
        name="Nome"
        id="Nome"
        value={(formik.values?.Nome) ?? ""}
        onChange={formik.handleChange}
        maxLength={100}
        disabled={!props.permitirAlterarDadosBasicos || props.somenteLeitura}
      /></div>
    </div>
  </>

  const campoInscricaoEstadual = <>
    <div className="_flex _mb-1">
      <label className="_font-normal w-[160px] _text-right _py-1 _pr-[10px]">Inscrição Estadual</label>
      <div><input
        className={estilosInputs.inputPadrao}
        name="InscricaoEstadual"
        id="InscricaoEstadual"
        value={(formik.values?.InscricaoEstadual) ?? ""}
        onChange={formik.handleChange}
        maxLength={20}
        disabled={!props.permitirAlterarDadosBasicos || props.somenteLeitura}
      /></div>
    </div>
  </>

  const campoContribuinte = <>
    <div>
      <label className="_font-normal w-[160px] _text-right _py-1 _pr-[10px] _cursor-pointer" htmlFor="clienteNaoCadastrado_Contribuinte">Contribuinte</label>
      <input
        className="w-[15px]"
        type="checkbox"
        name="Contribuinte"
        id="clienteNaoCadastrado_Contribuinte"
        onChange={formik.handleChange}
        checked={formik.values.Contribuinte ?? false}
        disabled={!props.permitirAlterarDadosBasicos || props.somenteLeitura}
      />
    </div>
  </>

  const campoInscricaoSuframa = <>
    <div className="_flex _mb-1">
      <label className="_font-normal w-[160px] _text-right _py-1 _pr-[10px]">Inscrição Suframa</label>
      <input
        className={`_w-[200px] ${estilosInputs.inputPadrao}`}
        name="InscricaoSuframa"
        id="InscricaoSuframa"
        value={(formik.values?.InscricaoSuframa) ?? ""}
        onChange={formik.handleChange}
        onBlur={() => {
          const erro = ValidarInscricaoSuframa(formik.values?.InscricaoSuframa) // 462219
          if (erro.length > 0) {
            globalMU.showErrorMessage(erro)
          }
         }}
        maxLength={40}
        disabled={!props.permitirAlterarDadosBasicos || props.somenteLeitura}
      />
    </div>
  </>

  const campoApelido = <>
    <div className="_flex _mb-1">
      <label className="_font-normal w-[160px] _text-right _py-1 _pr-[10px]">Apelido</label>
      <input
        className={`_w-[200px] ${estilosInputs.inputPadrao}`}
        name="Apelido"
        id="Apelido"
        value={(formik.values?.Apelido) ?? ""}
        onChange={formik.handleChange}
        disabled={!props.permitirAlterarDadosBasicos || props.somenteLeitura}
      />
    </div>
  </>

  const campoContato = <>
    <div className="_flex _mb-1">
      <label className="_font-normal w-[160px] _text-right _py-1 _pr-[10px]">Contato</label>
      <input
        className={`_w-[200px] ${estilosInputs.inputPadrao}`}
        name="Contato"
        id="Contato"
        value={(formik.values?.Contato) ?? ""}
        onChange={formik.handleChange}
        disabled={!props.permitirAlterarDadosBasicos || props.somenteLeitura}
      />
    </div>
  </>


  return (
    <form>
      <fieldset>
        {campoCnpjCpf}

        <div className="2xl:_flex ">
          {campoNome}

          {campoInscricaoEstadual}

          {campoContribuinte}
        </div>

        {campoInscricaoSuframa}

        {campoApelido}

        {campoContato}
      </fieldset>

    </form>
  );
};
